<ion-badge mode="md" [ngClass]="tipo ? (tipo | lowercase) : 'gray'">
    <ion-icon [name]="statusIcon(tipo)" *ngIf="statusIcon(tipo) !== 'ribbon-sharp'"></ion-icon>
    <ion-icon src="assets/ribbon.svg" *ngIf="statusIcon(tipo) === 'ribbon-sharp'"></ion-icon>
</ion-badge>